export const numYTicks = 10;
export const numXTicks = 10;
